/* My Acre — greenhouse "Commonly bought with" size auto-match (2026-08-10, Claude).
   On a greenhouse PDP, keeps the 3-Tier Shelving and Shade Cover Kit rows in the
   Commonly bought with block matched to the greenhouse size the customer has picked:
   correct variant added to cart, correct price, a "fits your size" line, and an
   "Ask us for your size" state when no stock size exists. Heater and louvre rows,
   and every other product's block, are left exactly as they are.
   Pure progressive enhancement, layered on snippets/product-form.liquid (.ma-ob)
   and assets/ma-brand-enhance.js (which reads the row's data-id live on click).
   If anything fails, the rows simply keep their default first variant. */
(function () {
  var root = document.querySelector('[data-ma-ob]');
  var buybox = document.querySelector('.ma-buybox');
  if (!root || !buybox) return;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* The greenhouse size the customer has selected, e.g. { w:"6", l:"8" } from "6ft x 8ft". */
  function currentWL() {
    var checked = buybox.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      var m = /(\d+)\s*ft\s*x\s*(\d+)\s*ft/i.exec(checked[i].value || '');
      if (m) return { w: m[1], l: m[2] };
    }
    var sel = buybox.querySelector('select[data-variants]');
    if (sel && sel.options[sel.selectedIndex]) {
      var m2 = /(\d+)\s*ft\s*x\s*(\d+)\s*ft/i.exec(sel.options[sel.selectedIndex].textContent || '');
      if (m2) return { w: m2[1], l: m2[2] };
    }
    return null;
  }

  /* Only run where there is a greenhouse size to match against. */
  if (!currentWL()) return;

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  /* How this accessory maps to the greenhouse: by width x length, or by length. */
  function matchType(product) {
    if (!product || !product.variants || product.variants.length < 2) return null;
    var first = product.options && product.options[0];
    var name = ((first && first.name) ? first.name : first || '') + '';
    name = name.toLowerCase();
    if (name.indexOf('size') >= 0) return 'wxl';
    if (name.indexOf('length') >= 0) return 'length';
    return null;
  }

  function findVariant(product, type, wl) {
    var needle = type === 'wxl' ? (wl.w + 'ft x ' + wl.l + 'ft') : (wl.l + 'ft long');
    needle = needle.toLowerCase();
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.available !== false && (v.title || '').toLowerCase().indexOf(needle) >= 0) return v;
    }
    return null;
  }

  /* Collect the accessory rows and their quick-view modals. The product handle
     comes from the modal's "View full details" link. */
  var entries = [];
  Array.prototype.forEach.call(root.querySelectorAll('.ma-ob__row'), function (row) {
    var idx = row.getAttribute('data-ma-ob-open');
    var modal = idx ? root.querySelector('[data-ma-ob-modal="' + idx + '"]') : null;
    var link = modal ? modal.querySelector('.ma-ob-modal__link') : null;
    var href = link ? link.getAttribute('href') : '';
    var hm = /\/products\/([^/?#]+)/.exec(href || '');
    if (!hm) return;
    entries.push({ row: row, modal: modal, handle: hm[1] });
  });
  if (!entries.length) return;

  var ready = entries.map(function (e) {
    return getProduct(e.handle).then(function (product) {
      e.product = product;
      e.type = matchType(product);
      if (!e.type) return;
      e.addBtn = e.row.querySelector('.ma-ob__add');
      e.priceEl = e.row.querySelector('.ma-ob__price');
      e.modalAdd = e.modal ? e.modal.querySelector('[data-ma-ob-modal-add]') : null;
      e.modalPrice = e.modal ? e.modal.querySelector('.ma-ob-modal__price') : null;
      var meta = e.row.querySelector('.ma-ob__meta');
      if (meta && !meta.querySelector('.ma-ob__fit')) {
        e.fit = document.createElement('span');
        e.fit.className = 'ma-ob__fit';
        if (e.priceEl) meta.insertBefore(e.fit, e.priceEl); else meta.appendChild(e.fit);
        e.ask = document.createElement('a');
        e.ask.className = 'ma-ob__ask';
        e.ask.href = '/pages/contact';
        e.ask.textContent = 'Ask us for your size';
        e.ask.style.display = 'none';
        meta.appendChild(e.ask);
      }
    });
  });

  function resetAdded(btn) {
    if (!btn) return;
    btn.classList.remove('is-added');
    btn.setAttribute('aria-pressed', 'false');
    btn.removeAttribute('data-line-key');
    if (btn.getAttribute('data-busy') !== '1') btn.textContent = 'Add';
  }

  function applyEntry(e, wl) {
    if (!e.type || !e.product) return;
    var v = findVariant(e.product, e.type, wl);
    if (v) {
      if (e.fit) {
        e.fit.textContent = v.title;
        e.fit.style.display = '';
        e.fit.classList.add('is-changed');
        setTimeout(function () { if (e.fit) e.fit.classList.remove('is-changed'); }, 700);
      }
      if (e.ask) e.ask.style.display = 'none';
      if (e.priceEl) { e.priceEl.style.display = ''; e.priceEl.textContent = money(v.price); }
      if (e.addBtn) {
        if (String(e.addBtn.getAttribute('data-id')) !== String(v.id)) resetAdded(e.addBtn);
        e.addBtn.setAttribute('data-id', v.id);
        e.addBtn.classList.remove('is-off');
        e.addBtn.removeAttribute('aria-disabled');
      }
      if (e.modalAdd) { e.modalAdd.setAttribute('data-target-id', v.id); e.modalAdd.disabled = false; }
      if (e.modalPrice) {
        var gst = e.modalPrice.querySelector('.ma-ob-modal__gst');
        e.modalPrice.textContent = money(v.price) + ' ';
        if (gst) e.modalPrice.appendChild(gst);
      }
    } else {
      if (e.fit) {
        e.fit.textContent = e.type === 'length'
          ? 'Longer than we stock, supplied in sections'
          : 'No stock cover for this size';
        e.fit.style.display = '';
        e.fit.classList.remove('is-changed');
      }
      if (e.priceEl) e.priceEl.style.display = 'none';
      if (e.ask) e.ask.style.display = '';
      if (e.addBtn) { resetAdded(e.addBtn); e.addBtn.classList.add('is-off'); e.addBtn.setAttribute('aria-disabled', 'true'); }
      if (e.modalAdd) e.modalAdd.disabled = true;
    }
  }

  function applyAll() {
    var wl = currentWL();
    if (!wl) return;
    entries.forEach(function (e) { applyEntry(e, wl); });
  }

  Promise.all(ready).then(function () {
    applyAll();
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('.ma-buybox')) setTimeout(applyAll, 60);
    });
  });
})();
